"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const getDefaultDueDate = () => new Date('1000-01-01T00:00:00Z').toISOString();
exports.default = getDefaultDueDate;
//# sourceMappingURL=getDefaultDueDate.js.map